module.exports = __webpack_public_path__ + "img/Edit.1c45b353.png";